/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { Row, Col } from 'react-bootstrap';
import { Button, TextField, Radio, RadioGroup } from '@material-ui/core';
import mControl from './General.Controler'
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
// import ImageUploader from 'react-images-upload';
//import FileBase64 from 'react-file-base64';
import Skeleton from 'react-loading-skeleton';

const noImage = "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"

const TaxService = (props) => {
    const kodeoutlet = props.kodeoutlet;
    const clientID = props.clientID
    const token = props.token
    const [isRefresh, setIsRefresh] = useState(true)
    const [logo, setLogo] = useState()
    const [footer, setFooter] = useState()
    const [isUploadFooter, setIsUploadFooter] = useState(false)
    const [isUploadLogo, setIsUploadLogo] = useState(false)
    const [form, setForm] = useState({
        useCaptainOrder: false,
        directPrint: false,
        useKitchenPrinter: false,
        printLogo: false,
        printFooter: false,
        footerText: '',
        printInvoice: 1,
        printCO: 1,
        kitchenFontSize: 1,
        jumlahBeep: 0,
        useGambar: false,
        jumlahItemOrderan: 0,
        rounding: "0",
        roundingDisplay: "0",
        transaksiHitungTax: false,
        usePreBill: false,
        tampilNamaCustomer: false,
        tampilKeterangan: false,
        taxServicePerDisplayHarga: false,
        cetakRekapProduk: false,
        cetakDelivery: false,
        cetakRekapPriceType: false,
        cetakRekapProdukTotal: false,
        hakReprintKitchen: false,
        tutupSesiOffline: false,
        hakOutletSetting: false,
        tutupSesiButuhHakAkses: false,
        closeBill: false,
        displayTaxServicePerc: false

    })
    useEffect(() => {
        setIsRefresh(false)
        if (isRefresh) {
            mControl.loadDetail(kodeoutlet, clientID, token).then(resp => {
                setForm({
                    ...resp,
                    rounding: resp.rounding.toString(),
                    roundingDisplay: resp.roundingDisplay.toString(),
                    useCaptainOrder: resp.useCaptainOrder || false,
                    directPrint: resp.directPrint || false,
                    useKitchenPrinter: resp.useKitchenPrinter || false,
                    printLogo: resp.printLogo || false,
                    printFooter: resp.printFooter || false,
                    footerText: resp.footerText || '',
                    printInvoice: resp.printInvoice || 1,
                    printCO: resp.printCO || 1,
                    kitchenFontSize: resp.kitchenFontSize || 1,
                    jumlahBeep: resp.jumlahBeep || 0,
                    useGambar: resp.useGambar || false,
                    jumlahItemOrderan: resp.jumlahItemOrderan || 0,
                    transaksiHitungTax: resp.transaksiHitungTax || false,
                    usePreBill: resp.usePreBill || false,
                    tampilNamaCustomer: resp.tampilNamaCustomer || false,
                    tampilKeterangan: resp.tampilKeterangan || false,
                    taxServicePerDisplayHarga: resp.taxServicePerDisplayHarga || false,
                    cetakRekapProduk: resp.cetakRekapProduk || false,
                    cetakDelivery: resp.cetakDelivery || false,
                    cetakRekapPriceType: resp.cetakRekapPriceType || false,
                    cetakRekapProdukTotal: resp.cetakRekapProdukTotal || false,
                    hakReprintKitchen: resp.hakReprintKitchen || false,
                    tutupSesiOffline: resp.tutupSesiOffline || false,
                    hakOutletSetting: resp.hakOutletSetting || false,
                    tutupSesiButuhHakAkses: resp.tutupSesiButuhHakAkses || false,
                    closeBill: resp.closeBill || false,
                    displayTaxServicePerc: resp.displayTaxServicePerc || false,
                });
                if (resp.logo) setLogo(`data:image/jpeg;base64,${resp.logo}`)
                if (resp.footer) setFooter(`data:image/jpeg;base64,${resp.footer}`)
            }).catch(err => {
                console.error(err);
            }).finally(() => setIsRefresh(false))
        }
        return () => {
        };
    }, [kodeoutlet, clientID, token, isRefresh]);
    const handleChange = (ev) => {
        let value
        const key = ev.target.id || ev.target.name;
        if (key === "footerText" || key === "printInvoice" || key === "printCO" || key === "kitchenFontSize" || key === "jumlahBeep" || key === "rounding" || key === "roundingDisplay" || key === "jumlahItemOrderan") {
            value = ev.target.value;
        } else {
            value = ev.target.checked;
        }
        var newForm = { ...form }
        newForm[key] = value;
        setForm(newForm);
    }

    const handleSaveSatting = () => {
        mControl.simpanPengaturanUmum(kodeoutlet, clientID, token, form).then(resp => {
            if (resp) {
                alert("Data berhasil disimpan")
                setIsRefresh(true)
            } else {
                alert("Gagal simpan data")
            }
        }).catch(err => {
            if (err.length > 0) {
                alert(err[0].message)
            } else if (typeof err) {
                alert(err.message)
            } else {
                console.log(err);
            }
        })

    }
    const handleImgFooter = (file) => {
        if (file.target.files[0].type === "image/jpeg" || file.target.files[0].type === "image/jpg" || file.target.files[0].type === "image/png") {
            setIsUploadFooter(true)
            const formData = new FormData();
            formData.append('file', file.target.files[0]);
            formData.append('kodeoutlet', kodeoutlet);
            return fetch(`${process.env.REACT_APP_URL}/upload/upload-footer`, {
                method: "POST",
                headers: {
                    'X-API-CLIENT-ID': clientID,
                    'X-API-TOKEN': token,
                },
                body: formData
            }).then(res => res.json())
                .then(resp => {
                    if (resp) {
                        alert("Gambar footer berhasil disimpan")
                        setIsRefresh(true)
                        setIsUploadFooter(false)
                    } else {
                        alert("Gagal simpan data")
                    }
                }).catch(err => {
                    if (err.length > 0) {
                        alert(err[0].message)
                    } else if (typeof err) {
                        alert(err.message)
                    } else {
                        console.log(err);
                    }
                })
            // const image = file.base64.replace(/^data:image\/[a-z]+;base64,/, "");
            // mControl.simpanImageFooter(kodeoutlet, clientID, token, image).then(resp => {
            //     if (resp) {
            //         alert("Gambar footer berhasil disimpan")
            //         setFooter(file.base64)
            //     } else {
            //         alert("Gagal simpan data")
            //     }
            // }).catch(err => {
            //     if (err.length > 0) {
            //         alert(err[0].message)
            //     } else if (typeof err) {
            //         alert(err.message)
            //     } else {
            //         console.log(err);
            //     }
            // })
        } else {
            return alert("Format gambar PNG ,JPG atau JPEG")
        }
    }
    const handleImgLogo = (file) => {
        if (file.target.files[0].type === "image/jpeg" || file.target.files[0].type === "image/jpg" || file.target.files[0].type === "image/png") {
            setIsUploadLogo(true)
            const formData = new FormData();
            formData.append('file', file.target.files[0]);
            formData.append('kodeoutlet', kodeoutlet);
            return fetch(`${process.env.REACT_APP_URL}/upload/upload-logo`, {
                method: "POST",
                headers: {
                    'X-API-CLIENT-ID': clientID,
                    'X-API-TOKEN': token,
                },
                body: formData
            }).then(res => res.json())
                .then(resp => {
                    if (resp) {
                        alert("Logo berhasil disimpan")
                        setIsRefresh(true)
                        setIsUploadLogo(false)
                    } else {
                        alert("Gagal simpan data")
                    }
                }).catch(err => {
                    if (err.length > 0) {
                        alert(err[0].message)
                    } else if (typeof err) {
                        alert(err.message)
                    } else {
                        console.log(err);
                    }
                })
            // const image = file.base64.replace(/^data:image\/[a-z]+;base64,/, "");
            // mControl.simpanLogo(kodeoutlet, clientID, token, image).then(resp => {
            //     if (resp) {
            //         alert("Logo berhasil disimpan")
            //         setLogo(file.base64)
            //     } else {
            //         alert("Gagal simpan data")
            //     }
            // }).catch(err => {
            //     if (err.length > 0) {
            //         alert(err[0].message)
            //     } else if (typeof err) {
            //         alert(err.message)
            //     } else {
            //         console.log(err);
            //     }
            // })
        } else {
            alert("Format gambar PNG ,JPG atau JPEG")
        }
    }
    const resetImgFooter = () => {
        mControl.resetImageFooter(kodeoutlet, clientID, token).then(resp => {
            if (resp) {
                alert("Gambar Footer berhasil direset")
                setFooter(null)
            } else {
                alert("Gagal simpan data")
            }
        }).catch(err => {
            if (err.length > 0) {
                alert(err[0].message)
            } else if (typeof err) {
                alert(err.message)
            } else {
                console.log(err);
            }
        })
    }
    const resetImgLogo = () => {
        mControl.resetLogo(kodeoutlet, clientID, token).then(resp => {
            if (resp) {
                alert("Logo berhasil direset")
                setLogo(null)
            } else {
                alert("Gagal simpan data")
            }
        }).catch(err => {
            if (err.length > 0) {
                alert(err[0].message)
            } else if (typeof err) {
                alert(err.message)
            } else {
                console.log(err);
            }
        })
    }
    return (
        <React.Fragment>
            <h6 className="headSetting">Manajemen Data</h6>
            <Col xs={12}>
                <Row>
                    <Col xs={12} md={4}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.useCaptainOrder}
                                    onChange={handleChange}
                                    id="useCaptainOrder"
                                    name="useCaptainOrder"
                                    color="primary"
                                />
                            }
                            label="Cetak Captain Order"
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.directPrint}
                                    onChange={handleChange}
                                    id="directPrint"
                                    name="directPrint"
                                    color="primary"
                                />
                            }
                            label="Cetak Tagihan Setelah Pembayaran"
                        />
                    </Col>
                    <Col xs={12} md={4}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.useKitchenPrinter}
                                    onChange={handleChange}
                                    id="useKitchenPrinter"
                                    name="useKitchenPrinter"
                                    color="primary"
                                />
                            }
                            label="Cetak Pesanan ke Dapur dan Bartender"
                        />
                    </Col>
                </Row>
            </Col>
            <h6 className="headSetting">Konfigurasi Struk</h6>
            <Col xs={12}>
                <Row>
                    <Col xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.printLogo}
                                    onChange={handleChange}
                                    id="printLogo"
                                    name="printLogo"
                                    color="primary"
                                />
                            }
                            label=" Cetak Logo pada Struk Belanja & Laporan"
                        /><br />
                        {form.printLogo && (
                            <React.Fragment>
                                {isUploadLogo ? (
                                    <Skeleton height={100} />
                                ) : (
                                    <React.Fragment>
                                        <img className="imgForm" alt="print logo" src={logo || `data:image/jpeg;base64,${noImage}`} /><br />
                                        {/* <FileBase64
                                                multiple={false}
                                                onDone={handleImgLogo.bind(this)} /> */}
                                        <input
                                            id="isPhoto"
                                            label="Gambar"
                                            type="file"
                                            onChange={handleImgLogo.bind(this)}
                                            accept="image/*"
                                        />
                                        <br />
                                    </React.Fragment>
                                )}
                                <Button variant="contained" color="primary" className="btnHapus" style={{ marginTop: 3 }} onClick={resetImgLogo}>Reset</Button>
                            </React.Fragment>
                        )}
                    </Col>
                    <Col xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.printFooter}
                                    onChange={handleChange}
                                    id="printFooter"
                                    name="printFooter"
                                    color="primary"
                                />
                            }
                            label="Cetak Footer"
                        />
                        {form.printFooter && (
                            <React.Fragment>
                                <TextField
                                    id="footerText"
                                    name="footerText"
                                    label="Text"
                                    fullWidth
                                    required
                                    multiline={true}
                                    value={form.footerText}
                                    onChange={handleChange}
                                    rows={2}
                                />
                                {isUploadFooter ? (
                                    <Skeleton height={100} />
                                ) : (
                                    <React.Fragment>
                                        <img className="imgForm" alt="print logo" src={footer || `data:image/jpeg;base64,${noImage}`} /><br />
                                        {/* <FileBase64
                                    multiple={false}
                                    onDone={handleImgFooter.bind(this)} /> */}
                                        <input
                                            id="isPhoto"
                                            label="Gambar"
                                            type="file"
                                            onChange={handleImgFooter.bind(this)}
                                            accept="image/*"
                                        />
                                        <br />
                                    </React.Fragment>
                                )}
                                <Button variant="contained" color="primary" className="btnHapus" style={{ marginTop: 3 }} onClick={resetImgFooter}>Reset</Button>
                            </React.Fragment>
                        )}
                    </Col>
                    <Col xs={12} md={6}>
                        <TextField
                            id="printInvoice"
                            name="printInvoice"
                            label=" Print Invoice"
                            fullWidth
                            required
                            multiline={false}
                            value={form.printInvoice}
                            onChange={handleChange}
                            type="number"

                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <TextField
                            id="printCO"
                            name="printCO"
                            label=" Print CO"
                            fullWidth
                            required
                            multiline={false}
                            value={form.printCO}
                            onChange={handleChange}
                            type="number"

                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <TextField
                            id="kitchenFontSize"
                            name="kitchenFontSize"
                            label="Font Size untuk Kitchen dan Bartender (1 sampai 8)"
                            fullWidth
                            required
                            multiline={false}
                            value={form.kitchenFontSize}
                            onChange={handleChange}
                            type="number"

                        /></Col>
                    <Col xs={12} md={6}>
                        <TextField
                            id="jumlahBeep"
                            name="jumlahBeep"
                            label="Jumlah Beep (Maksimal 9)"
                            fullWidth
                            required
                            multiline={false}
                            value={form.jumlahBeep}
                            onChange={handleChange}
                            type="number"

                        />
                    </Col>
                    <Col xs={12} md={6}>
                        <FormControlLabel
                            control={
                                <Switch
                                    checked={form.displayTaxServicePerc}
                                    onChange={handleChange}
                                    id="displayTaxServicePerc"
                                    name="displayTaxServicePerc"
                                    color="primary"
                                />
                            }
                            label="Cetak nominal persentase tax & service"
                        />
                    </Col>
                </Row>
                <h6 className="headSetting" style={{ marginTop: 20 }}>Konfigurasi Menu</h6>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.useGambar}
                                        onChange={handleChange}
                                        id="useGambar"
                                        name="useGambar"
                                        color="primary"
                                    />
                                }
                                label="Menu Menampilkan Gambar"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <TextField
                                id="jumlahItemOrderan"
                                name="jumlahItemOrderan"
                                label="Jumlah barang per halaman untuk list orderan"
                                fullWidth
                                required
                                value={form.jumlahItemOrderan}
                                onChange={handleChange}

                            />
                        </Col>
                    </Row>
                </Col>
                <h6 className="headSetting" style={{ marginTop: 5 }}>Rounding Pembayaran</h6>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} md={12} className="bgRound">
                            <RadioGroup
                                aria-label="rounding"
                                name="rounding"
                                id="rounding"
                                onChange={handleChange}
                                value={form.rounding}
                            >
                                <FormControlLabel value="0" control={<Radio checked={form.rounding === "0"} />} label="Rounding ke 2 desimal di belakang koma" />
                                <FormControlLabel value="1" control={<Radio checked={form.rounding === "1"} />} label="Rounding ke 0 desimal di belakang koma" />
                                <FormControlLabel value="2" control={<Radio checked={form.rounding === "2"} />} label="Rounding ke atas hingga 500 terdekat" />
                                <FormControlLabel value="3" control={<Radio checked={form.rounding === "3"} />} label="Rounding ke kelipatan 1000 terdekat" />
                                <FormControlLabel value="4" control={<Radio checked={form.rounding === "4"} />} label="Rounding kebawah ke 100 terdekat" />
                                <FormControlLabel value="5" control={<Radio checked={form.rounding === "5"} />} label="Rounding kebawah ke 500 terdekat" />
                                <FormControlLabel value="6" control={<Radio checked={form.rounding === "6"} />} label="Rounding kebawah ke 1.000 terdekat" />
                                <FormControlLabel value="7" control={<Radio checked={form.rounding === "7"} />} label="Rounding ke atas hingga 1.000 terdekat" />
                            </RadioGroup>
                        </Col>
                    </Row>
                </Col>
                <h6 className="headSetting" style={{ marginTop: 5 }}>Rounding Display</h6>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} md={12} className="bgRound">
                            <RadioGroup
                                aria-label="roundingDisplay"
                                name="roundingDisplay"
                                id="roundingDisplay"
                                onChange={handleChange}
                                value={form.roundingDisplay}
                            >
                                <FormControlLabel value="0" control={<Radio checked={form.roundingDisplay === "0"} />} label="Rounding ke 2 desimal di belakang koma" />
                                <FormControlLabel value="1" control={<Radio checked={form.roundingDisplay === "1"} />} label="Rounding ke 0 desimal di belakang koma" />
                            </RadioGroup>
                        </Col>
                    </Row>
                </Col>
                <h6 className="headSetting" style={{ marginTop: 20 }}>Transaksi</h6>
                <Col xs={12}>
                    <Row>
                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.transaksiHitungTax}
                                        onChange={handleChange}
                                        id="transaksiHitungTax"
                                        name="transaksiHitungTax"
                                        color="primary"
                                    />
                                }
                                label="Nominal pending bill include service & tax"
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.usePreBill}
                                        onChange={handleChange}
                                        id="usePreBill"
                                        name="usePreBill"
                                        color="primary"
                                    />
                                }
                                label=" Pre-BILL"
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.tampilNamaCustomer}
                                        onChange={handleChange}
                                        id="tampilNamaCustomer"
                                        name="tampilNamaCustomer"
                                        color="primary"
                                    />
                                }
                                label="Tampil Nama Customer"
                            />
                        </Col>
                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.tampilKeterangan}
                                        onChange={handleChange}
                                        id="tampilKeterangan"
                                        name="tampilKeterangan"
                                        color="primary"
                                    />
                                }
                                label="Tampil Keterangan"
                            />
                        </Col>

                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.cetakRekapPriceType}
                                        onChange={handleChange}
                                        id="cetakRekapPriceType"
                                        name="cetakRekapPriceType"
                                        color="primary"
                                    />
                                }
                                label="Cetak Laporan Rekapitulasi (Berdasarkan Price Type)"
                            />
                        </Col>

                        <Col xs={12} md={6}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.taxServicePerDisplayHarga }
                                        onChange={handleChange}
                                        id="taxServicePerDisplayHarga"
                                        name="taxServicePerDisplayHarga"
                                        color="primary"
                                    />
                                }
                                label="Tax dan Service berdasarkan masing-masing profil harga"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.cetakRekapProduk}
                                        onChange={handleChange}
                                        id="cetakRekapProduk"
                                        name="cetakRekapProduk"
                                        color="primary"
                                    />
                                }
                                label="Cetak Laporan Rekapitulasi (Berdasarkan Produk)"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.cetakRekapProdukTotal}
                                        onChange={handleChange}
                                        id="cetakRekapProdukTotal"
                                        name="cetakRekapProdukTotal"
                                        color="primary"
                                    />
                                }
                                label="Cetak Laporan Rekapitulasi Item (Berdasarkan Produk dan Kategori)"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.cetakDelivery}
                                        onChange={handleChange}
                                        id="cetakDelivery"
                                        name="cetakDelivery"
                                        color="primary"
                                    />
                                }
                                label="Cetak Laporan Delivery"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.tutupSesiOffline}
                                        onChange={handleChange}
                                        id="tutupSesiOffline"
                                        name="tutupSesiOffline"
                                        color="primary"
                                    />
                                }
                                label="Tutup Sesi Tanpa Koneksi Internet"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.hakOutletSetting}
                                        onChange={handleChange}
                                        id="hakOutletSetting"
                                        name="hakOutletSetting"
                                        color="primary"
                                    />
                                }
                                label="Printer Setting"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.tutupSesiButuhHakAkses}
                                        onChange={handleChange}
                                        id="tutupSesiButuhHakAkses"
                                        name="tutupSesiButuhHakAkses"
                                        color="primary"
                                    />
                                }
                                label="Tutup Sesi Butuh Hak Akses"
                            />
                        </Col>
                        <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.closeBill}
                                        onChange={handleChange}
                                        id="closeBill"
                                        name="closeBill"
                                        color="primary"
                                    />
                                }
                                label="Tutup Sesi Wajib Close Bill"
                            />
                        </Col>
                        {/* <Col xs={12} md={12}>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={form.hakReprintKitchen}
                                        onChange={handleChange}
                                        id="hakReprintKitchen"
                                        name="hakReprintKitchen"
                                        color="primary"
                                    />
                                }
                                label="Cetak Ulang Dapur & Bartender"
                            />
                        </Col> */}
                    </Row>
                </Col>
            </Col>
            <Col xs={12} className="text-center" style={{ marginTop: 20 }}>
                <Button variant="contained" color="primary" onClick={handleSaveSatting}>Simpan</Button>
            </Col>


        </React.Fragment>
    );
}
export default TaxService;